import { handleActions } from 'redux-actions';
import * as signaturesActions from '../../actions/signatures/signaturesActions';

let initialState = {
  signatures: [],
  loading: false,
  errorMessage: '',
};

export const signatures = handleActions(
  {
    //  get profile info
    [signaturesActions.getAllSignatures]: (state, action) => {
      return { ...state, loading: true };
    },
    [signaturesActions.getAllSignaturesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        signatures: payload,
        // signatureTypes: payload.signatureTypes,
        // signaturesStat: payload.signaturesStat,
        loading: false,
      };
    },
    [signaturesActions.getAllSignaturesFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false,
      };
    },
  },
  initialState
);
